import { API } from './axios';

const getFaqs = async () => {
  try {
    const res = await API.get('/faqs');
    return res.data;
  } catch (error) {
    console.error('Error fetching FAQs:', error);
  }
};

export { getFaqs };
